
import React, { useEffect, useState, useCallback } from "react";
import cn from "classnames";
import Master from "screen/Master";
import styles from "./AddInvoiceComponent.module.scss";
import styled from "styled-components";
import TaxAmountTable from "components/Tables/TaxAmountTable";
import Table from "./common/Table";
import { Link } from "react-router-dom";
import { getRequestInPricing as getRequestForInvoice } from "services/axiosBaseClient.pricing";
import {
  getRequestInAssets as getRequest,
  // postRequestInAssets as postRequest,
  // putRequestInAssets as putRequest,
} from "services/axiosAssetsBaseClient";
import { getRequest as getEnterprise } from "services/axiosBaseClient";
import { postRequest, putRequest } from "services/axiosBaseClient";
import moment from "moment";
import notificationService from "services/notification.service";
import { useHistory } from "react-router-dom";

var id = undefined;
var action;
var view = undefined;
var readOnlyField = false;
var onlyView = false;
var updateView = false;
var invoiceDate;
var modeOfPayment = "Wallet";

const Styles = styled.div``;

function AddInvoiceView(props) {
  view = props?.match?.params?.view;
  id = props?.match?.params?.id;

  const intialFormValue = {
    invoiceNumber: "",
    invoiceDate: "",
    vin: "",
    driverName: "",
    siteName: "",
    stationNumber: "",
    existingBatteryIdA: "",
    exchangeBatteryIdA: "",
    existingBatteryAcurrentCharge: "",
    exchangeBatteryAcurrentCharge: "",
    existingBatteryIdB: "",
    exchangeBatteryIdB: "",
    existingBatteryBcurrentCharge: "",
    exchangeBatteryBcurrentCharge: "",
    totalEnergyReceived: "",
    unitEnergyCost: "",
    totalEnergyExchanges: "",
    totalEnergyExchangeINR: "",
    totalEnergyGiven: "",
    remark: "",
  };

  const [formValues, setFormValues] = useState(intialFormValue);
  const [formErrors, setFormErrors] = useState("");
  const [title, setTitle] = useState("Invoice Details");
  const [siteList, setSiteList] = useState([]);
  const [stationList, setStationList] = useState([]);
  const [showInvoice, setshowInvoice] = useState(false);
  const [invoiceDetails, setInvoiceDetails] = useState([]);
  const [hideDropdown, setHideDropdown] = useState(false);
  const history = useHistory();

  const taxData = [
    // createData(tax.serialnumber,tax.taxname,tax.taxrate,tax.taxamount),
  ];

  const getSite = useCallback(async () => {
    await getRequest(`bss/siteInfo`)
      .then((res) => {
        if (res?.data?.count >= 1) {
          setSiteList(res?.data?.sites);
        }
      })
      .catch((error) => {
        notificationService.showNonBlacklistedError(
          error?.config?.url,
          error?.response?.data?.message
        );
      });
  }, []);

  const getStation = useCallback(async (id) => {
    await getRequest(`bss/swappingStation/getswapStationInfo?siteId=` + id)
      .then((res) => {
        if (res?.data?.count >= 1) {
          setStationList(res?.data?.swapStationList);
        }
      })
      .catch((error) => {
        notificationService.showNonBlacklistedError(
          error?.config?.url,
          error?.response?.data?.message
        );
      });
  }, []);

  const getInvoiceDataByID = async (id) => {
    await getEnterprise("bss/getInvoiceDetails?invoiceNumber=" + id)
      .then((res) => {
        if (res.data != null) {
          patchForm(res?.data);
          setSiteList(res.data);
          setStationList(res?.data);
          setInvoiceDetails(res?.data[0]);
        }
      })
      .catch((error) => {
        notificationService.showNonBlacklistedError(
          error?.config?.url,
          error?.response?.data?.message
        );
      });
  };

  const validate = (formValues) => {
    const errors = {};

    if (!formValues.driverName) {
      errors.driverName = "Driver Name is required!";
    } else {
      errors.driverName = "";
    }

    if (!formValues.vin) {
      errors.vin = "VIN is required!";
    } else {
      errors.vin = "";
    }

    if (!formValues.siteName) {
      errors.siteName = "Site Name is required!";
    } else {
      errors.siteName = "";
    }

    if (!formValues.stationNumber) {
      errors.stationNumber = "Station Number is required!";
    } else {
      errors.stationNumber = "";
    }

    setFormErrors(errors);
    return errors;
  };

  useEffect(() => {
    if (id != undefined && view == undefined) {
      updateView = false;
      readOnlyField = true;
      onlyView = false;
      setTitle("Update Invoice");
      action = "Update";
      setshowInvoice(true);
      getInvoiceDataByID(id);
      setHideDropdown(true);
    } else if (id != undefined && view != undefined) {
      readOnlyField = true;
      updateView = true;
      onlyView = true;
      setTitle("Invoice Details");
      action = "View";
      getInvoiceDataByID(id);
      setshowInvoice(true);
      setHideDropdown(true);
    } else {
      updateView = false;
      readOnlyField = false;
      onlyView = false;
      setTitle("Add Invoice");
      action = "Submit";
      var date = new Date();
      invoiceDate = moment(date).format("DD-MM-YYYY hh:mm A");
    }

    getSite();
  }, []);

  const calculateInvoice = (e) => {
    e.preventDefault();
    let result = validate(formValues);

    var temp = [];

    if (formValues?.exchangeBatteryIdA !== "") {
      temp.push({ exchangeBatteryNameA: formValues?.exchangeBatteryIdA });
    }
    if (formValues?.existingBatteryIdA !== "") {
      temp.push({ existingBatteryNameA: formValues?.existingBatteryIdA });
    }
    if (formValues?.exchangeBatteryAcurrentCharge !== "") {
      temp.push({
        exchangeBatteryAcurrentCharge:
          formValues?.exchangeBatteryAcurrentCharge,
      });
    }
    if (formValues?.existingBatteryAcurrentCharge !== "") {
      temp.push({
        existingBatteryAcurrentCharge:
          formValues?.existingBatteryAcurrentCharge,
      });
    }
    if (formValues?.exchangeBatteryIdB !== "") {
      temp.push({ exchangeBatteryNameB: formValues?.exchangeBatteryIdB });
    }
    if (formValues?.existingBatteryIdB !== "") {
      temp.push({ existingBatteryNameA: formValues?.existingBatteryIdA });
    }
    if (formValues?.exchangeBatteryBcurrentCharge !== "") {
      temp.push({
        exchangeBatteryBcurrentCharge:
          formValues?.exchangeBatteryBcurrentCharge,
      });
    }
    if (formValues?.existingBatteryBcurrentCharge !== "") {
      temp.push({
        existingBatteryBcurrentCharge:
          formValues?.existingBatteryBcurrentCharge,
      });
    }

    var batteryDetails = [];
    if (temp?.length === 4) {
      batteryDetails.push({
        exchangedBattery: {
          batteryId: formValues?.exchangeBatteryIdA,
          currentCharge: formValues?.exchangeBatteryAcurrentCharge,
        },
        existingBattery: {
          batteryId: formValues?.existingBatteryIdA,
          currentCharge: formValues?.existingBatteryAcurrentCharge,
        },
      });
    } else if (temp?.length === 8) {
      batteryDetails.push(
        {
          exchangedBattery: {
            batteryId: formValues?.exchangeBatteryIdA,
            currentCharge: formValues?.exchangeBatteryAcurrentCharge,
          },
          existingBattery: {
            batteryId: formValues?.existingBatteryIdA,
            currentCharge: formValues?.existingBatteryAcurrentCharge,
          },
        },
        {
          exchangedBattery: {
            batteryId: formValues?.exchangeBatteryIdB,
            currentCharge: formValues?.exchangeBatteryBcurrentCharge,
          },
          existingBattery: {
            batteryId: formValues?.existingBatteryIdB,
            currentCharge: formValues?.existingBatteryBcurrentCharge,
          },
        }
      );
    }

    if (Object.values(result).every((x) => x === "")) {
      if (action === "Submit") {
        const payload = {
          batteryDetails,
          driverName: formValues?.driverName,
          siteId: formValues?.siteName,
          swappingStationId: formValues?.stationNumber,
          vin: formValues?.vin,
        };

        try {
          postRequest("bss/calculateEnergyPrice", payload)
            .then((res) => {
              setshowInvoice(true);
              setInvoiceDetails(res?.data);
            })
            .catch((error) => {
              console.log(error, "ERROR");
              if (
                error?.response?.data?.statusCode === 404 ||
                error?.response?.data?.statusCode === 500
              ) {
                notificationService.showNonBlacklistedError(
                  error?.config?.url,
                  error?.response?.data?.message
                );
              }
            });
        } catch (error) {
          console.log(error);
        }
      }
    }
  };

  const handleSubmit = (e) => {
    var input = e?.view?.location?.pathname;
    const [name, invoicePath, invoiceType, invoiceNumber] = input.split("/");
    var temp = [];

    if (formValues?.exchangeBatteryIdA !== "") {
      temp.push({ exchangeBatteryNameA: formValues?.exchangeBatteryIdA });
    }
    if (formValues?.existingBatteryIdA !== "") {
      temp.push({ existingBatteryNameA: formValues?.existingBatteryIdA });
    }
    if (formValues?.exchangeBatteryAcurrentCharge !== "") {
      temp.push({
        exchangeBatteryAcurrentCharge:
          formValues?.exchangeBatteryAcurrentCharge,
      });
    }
    if (formValues?.existingBatteryAcurrentCharge !== "") {
      temp.push({
        existingBatteryAcurrentCharge:
          formValues?.existingBatteryAcurrentCharge,
      });
    }
    if (formValues?.exchangeBatteryIdB !== "") {
      temp.push({ exchangeBatteryNameB: formValues?.exchangeBatteryIdB });
    }
    if (formValues?.existingBatteryIdB !== "") {
      temp.push({ existingBatteryNameA: formValues?.existingBatteryIdA });
    }
    if (formValues?.exchangeBatteryBcurrentCharge !== "") {
      temp.push({
        exchangeBatteryBcurrentCharge:
          formValues?.exchangeBatteryBcurrentCharge,
      });
    }
    if (formValues?.existingBatteryBcurrentCharge !== "") {
      temp.push({
        existingBatteryBcurrentCharge:
          formValues?.existingBatteryBcurrentCharge,
      });
    }

    var batteryDetails = [];
    if (temp?.length === 4) {
      batteryDetails.push({
        exchangedBattery: {
          batteryId: formValues?.exchangeBatteryIdA,
          currentCharge: formValues?.exchangeBatteryAcurrentCharge,
        },
        existingBattery: {
          batteryId: formValues?.existingBatteryIdA,
          currentCharge: formValues?.existingBatteryAcurrentCharge,
        },
      });
    } else if (temp?.length === 8) {
      batteryDetails.push(
        {
          exchangedBattery: {
            batteryId: formValues?.exchangeBatteryIdA,
            currentCharge: formValues?.exchangeBatteryAcurrentCharge,
          },
          existingBattery: {
            batteryId: formValues?.existingBatteryIdA,
            currentCharge: formValues?.existingBatteryAcurrentCharge,
          },
        },
        {
          exchangedBattery: {
            batteryId: formValues?.exchangeBatteryIdB,
            currentCharge: formValues?.exchangeBatteryBcurrentCharge,
          },
          existingBattery: {
            batteryId: formValues?.existingBatteryIdB,
            currentCharge: formValues?.existingBatteryBcurrentCharge,
          },
        }
      );
    }

    e.preventDefault();
    const payload = {
      batteryDetails,
      driverName: formValues?.driverName,
      invoiceDate: invoiceDate,
      modeOfPayment: modeOfPayment,
      remarks: formValues?.remark,
      siteId: formValues?.siteName,
      swappingStationId: formValues?.stationNumber,
      vin: formValues?.vin,
    };

    var updatedRemark = formValues?.remark;
    if (invoiceType === "UpdateInvoice") {
      putRequest(
        "bss/updateInvoice?invoiceNumber=" + id + "&remarks=" + updatedRemark
      )
        .then((res) => {
          if (res && res?.data) {
            history.push({
              pathname: "/Invoice",
            });
            notificationService.showNonBlacklisted(
              res?.config?.url,
              res?.data?.message
            );
          }
        })
        .catch((error) => {
          notificationService.showNonBlacklistedError(
            error?.config?.url,
            error?.response?.data?.message
          );
        });
    } else if (invoiceType === "AddInvoice") {
      postRequest("bss/addInvoice", payload)
        .then((res) => {
          if (res && res?.data) {
            history.push({
              pathname: "/Invoice",
            });
            notificationService.showNonBlacklisted(
              res?.config?.url,
              res?.message
            );
          }
        })
        .catch((error) => {
          notificationService.showNonBlacklistedError(
            error?.config?.url,
            error?.response?.data?.message
          );
        });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    // setFormValues({ ...formValues, [name]: value });
    if (name === "driverName") {
      setFormValues({
        ...formValues,
        ["driverName"]: value,
      });
    }
    if (name === "vin") {
      setFormValues({
        ...formValues,
        ["vin"]: value,
      });
    }
    if (name === "siteName") {
      getStation(value);
      setFormValues({
        ...formValues,
        ["siteName"]: value,
      });
    }
    if (name === "stationNumber") {
      setFormValues({
        ...formValues,
        ["stationNumber"]: value,
      });
    }
    if (name === "existingBatteryIdA") {
      setFormValues({
        ...formValues,
        ["existingBatteryIdA"]: value,
      });
    }
    if (name === "exchangeBatteryIdA") {
      setFormValues({
        ...formValues,
        ["exchangeBatteryIdA"]: value,
      });
    }
    if (name === "existingBatteryAcurrentCharge") {
      setFormValues({
        ...formValues,
        ["existingBatteryAcurrentCharge"]: value,
      });
    }
    if (name === "exchangeBatteryAcurrentCharge") {
      setFormValues({
        ...formValues,
        ["exchangeBatteryAcurrentCharge"]: value,
      });
    }
    if (name === "existingBatteryIdB") {
      setFormValues({
        ...formValues,
        ["existingBatteryIdB"]: value,
      });
    }
    if (name === "exchangeBatteryIdB") {
      setFormValues({
        ...formValues,
        ["exchangeBatteryIdB"]: value,
      });
    }
    if (name === "existingBatteryBcurrentCharge") {
      setFormValues({
        ...formValues,
        ["existingBatteryBcurrentCharge"]: value,
      });
    }
    if (name === "exchangeBatteryBcurrentCharge") {
      setFormValues({
        ...formValues,
        ["exchangeBatteryBcurrentCharge"]: value,
      });
    }
    if (name === "totalEnergyReceived") {
      setFormValues({
        ...formValues,
        ["totalEnergyReceived"]: value,
      });
    }
    if (name === "totalEnergyGiven") {
      setFormValues({
        ...formValues,
        ["totalEnergyGiven"]: value,
      });
    }
    if (name === "curentChanged1") {
      setFormValues({
        ...formValues,
        ["curentChanged1"]: value,
      });
    }
    if (name === "curentChanged2") {
      setFormValues({
        ...formValues,
        ["curentChanged2"]: value,
      });
    }
    if (name === "remark") {
      setFormValues({
        ...formValues,
        ["remark"]: value.replace(/[&*<>!^]/g, ''),
      });
    }
  };

  const patchForm = (data) => {
    setFormValues({
      invoiceNumber: data[0]?.invoiceNumber,
      invoiceDate: data[0]?.invoiceDateTime,
      vin: data[0]?.vin,
      siteName: data[0]?.siteName,
      stationName: data[0]?.swappingStationName,
      driverName: data[0]?.driverName,
      existingBatteryIdA:
        data[0]?.batteryDetails[0]?.existingBattery?.name,
      //  readOnlyField
      //   ? data[0]?.batteryDetails[0]?.existingBattery?.name
      //   : data[0]?.batteryDetails[0]?.existingBattery?.batteryId,
      exchangeBatteryIdA:
        data[0]?.batteryDetails[0]?.exchangedBattery?.name,
      // readOnlyField
      //   ? data[0]?.batteryDetails[0]?.exchangedBattery?.name
      //   : data[0]?.batteryDetails[0]?.exchangedBattery?.batteryId,
      existingBatteryAcurrentCharge:
        data[0]?.batteryDetails[0]?.existingBattery?.currentCharge,
      exchangeBatteryAcurrentCharge:
        data[0]?.batteryDetails[0]?.exchangedBattery?.currentCharge,
      totalEnergyReceived: data[0]?.totalEnergyReceived,
      totalEnergyGiven: data[0]?.totalEnergyGiven,
      unitEnergyCost: data[0]?.unitEnergyCost,
      totalEnergyExchanges: data[0]?.totalEnergy,
      existingBatteryIdB:
        data[0]?.batteryDetails[1]?.existingBattery?.batteryId,
      exchangeBatteryIdB:
        data[0]?.batteryDetails[1]?.exchangedBattery?.batteryId,
      totalEnergyExchangeINR: data[0]?.totalEnergyPrice,
      existingBatteryBcurrentCharge:
        data[0]?.batteryDetails[1]?.existingBattery?.currentCharge,
      exchangeBatteryBcurrentCharge:
        data[0]?.batteryDetails[1]?.exchangedBattery?.currentCharge,
      remark: data[0]?.remarks,
    });
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "S.NO.",
        accessor: "serialNumber",
      },
      {
        Header: "Tax Name",
        accessor: "taxname",
      },
      {
        Header: "Tax Rate (%)",
        accessor: "taxrate",
        Cell: (row) => {
          return (
            <div >{row.row?.original?.taxrate ? row.row?.original?.taxrate + "%" : <span>NA</span>}</div>
          )
        },
      },
      {
        Header: "Tax Amount(in INR)",
        accessor: "taxamount",
      },
    ],
    []
  );

  var data = [];

  invoiceDetails?.taxCalcDetail?.map((item, i) => {
    data.push({
      serialNumber: i + 1,
      taxname: item?.taxName,
      taxrate: item?.taxPercentage ? Number(item?.taxPercentage).toFixed(2) : 0,
      taxamount: item?.taxAmount ? Number(item?.taxAmount).toFixed(2) : 0,
    });
  });

  data.push({
    serialNumber: "Total Tax Amount",
    taxamount: invoiceDetails?.totalTaxAmount,
  });

  return (
    <>
      <div className={cn(styles.flex_item1)}>
        <div className={cn(styles.flex1)}>
          <h2 className={cn(styles.medium_title, styles.medium_title_layout)}>
            {"Invoice"}
          </h2>

          <div className={cn(styles.group, styles.group_layout)}>
            <form>
              <div className={cn(styles.flex3, styles.flex3_layout)}>
                <h3 className={cn(styles.subtitle, styles.subtitle_layout)}>
                  {title}
                </h3>
                <hr className={cn(styles.line, styles.line_layout)} />
                <div className={cn(styles.flex2, styles.flex2_layout)}>
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                      <div
                        className={cn(
                          styles.text_body,
                          styles.text_body_layout
                        )}
                      >
                        {"Invoice no"}
                      </div>
                      <input
                        name="zone"
                        className={cn(styles.line1, styles.line1_layout)}
                        value={formValues?.invoiceNumber}
                        disabled={readOnlyField}
                      />
                    </div>
                  </div>

                  <div className={cn(styles.flex2_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                      <div
                        className={cn(
                          styles.text_body,
                          styles.text_body_layout
                        )}
                      >
                        {"Invoice Date"}
                      </div>
                      <input
                        name="invoiceDate"
                        className={cn(styles.line1, styles.line1_layout)}
                        value={
                          id != undefined
                            ? formValues?.invoiceDate
                            : invoiceDate
                        }
                        disabled={readOnlyField}
                      />
                    </div>
                  </div>
                </div>
                <div className={cn(styles.flex2, styles.flex2_layout)}>
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                      <div
                        className={cn(
                          styles.text_body,
                          styles.text_body_layout
                        )}
                      >
                        {"VIN*"}
                      </div>
                      <input
                        name="vin"
                        className={cn(styles.line1, styles.line1_layout)}
                        value={formValues?.vin}
                        disabled={readOnlyField}
                        onChange={handleChange}
                        maxLength="17"
                      />
                    </div>
                    <p>{formErrors?.vin}</p>
                  </div>

                  <div className={cn(styles.flex2_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                      <div
                        className={cn(
                          styles.text_body,
                          styles.text_body_layout
                        )}
                      >
                        {"Driver Name*"}
                      </div>
                      <input
                        name="driverName"
                        className={cn(styles.line1, styles.line1_layout)}
                        value={formValues?.driverName}
                        disabled={readOnlyField}
                        onChange={handleChange}
                      />
                    </div>
                    <p>{formErrors?.driverName}</p>
                  </div>
                </div>
              </div>
            </form>
            <div className={cn(styles.flex2, styles.flex2_layout)}></div>
          </div>
          {/* //------- */}

          <div className={cn(styles.group, styles.group_layout)}>
            <form>
              <div className={cn(styles.flex3, styles.flex3_layout)}>
                <h3 className={cn(styles.subtitle, styles.subtitle_layout)}>
                  {"Swap Details"}
                </h3>
                <hr className={cn(styles.line, styles.line_layout)} />
                <div className={cn(styles.flex2, styles.flex2_layout)}>
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                      <div
                        className={cn(
                          styles.text_body,
                          styles.text_body_layout
                        )}
                      >
                        {"Swap Site Name*"}
                      </div>
                      {hideDropdown ? (
                        <input
                          name="siteName"
                          className={cn(
                            styles.line1,
                            styles.line1_layout,
                            styles.style_select
                          )}
                          value={formValues?.siteName}
                          onChange={handleChange}
                          disabled={readOnlyField}
                        />
                      ) : (
                        <select
                          name="siteName"
                          className={cn(
                            styles.line1,
                            styles.line1_layout,
                            styles.style_select
                          )}
                          value={formValues?.siteName}
                          onChange={handleChange}
                          disabled={readOnlyField}
                        >
                          {!readOnlyField ? (
                            <option value="-1">Select Site</option>
                          ) : (
                            ""
                          )}
                          {siteList?.map((val) => {
                            return (
                              <option value={val?.siteId}>
                                {val?.siteName}
                              </option>
                            );
                          })}
                        </select>
                      )}
                    </div>
                    <p>{formErrors?.siteName}</p>
                  </div>

                  <div className={cn(styles.flex2_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                      <div
                        className={cn(
                          styles.text_body,
                          styles.text_body_layout
                        )}
                      >
                        {"Swap Station Name*"}
                      </div>
                      {hideDropdown ? (
                        <input
                          name="stationNumber"
                          className={cn(
                            styles.line1,
                            styles.line1_layout,
                            styles.style_select
                          )}
                          value={formValues?.stationName}
                          onChange={handleChange}
                          disabled={readOnlyField}
                        />
                      ) : (
                        <select
                          name="stationNumber"
                          className={cn(
                            styles.line1,
                            styles.line1_layout,
                            styles.style_select
                          )}
                          value={formValues?.stationNumber}
                          onChange={handleChange}
                          disabled={readOnlyField}
                        >
                          {!readOnlyField ? (
                            <option value="-1">Select Station</option>
                          ) : (
                            ""
                          )}
                          {stationList?.map((val) => {
                            return (
                              <option value={val?.swapStationId}>
                                {id != undefined
                                  ? val?.swappingStationName
                                  : val?.swapStationName}
                              </option>
                            );
                          })}
                        </select>
                      )}
                    </div>
                    <p>{formErrors?.stationNumber}</p>
                  </div>
                </div>
              </div>
            </form>
            <div className={cn(styles.flex2, styles.flex2_layout)}></div>
          </div>
          {/* /// */}

          <div className={cn(styles.group, styles.group_layout)}>
            <form>
              <div className={cn(styles.flex3, styles.flex3_layout)}>
                <h3 className={cn(styles.subtitle, styles.subtitle_layout)}>
                  {"Battery Details"}
                </h3>
                <hr className={cn(styles.line, styles.line_layout)} />
                <div className={cn(styles.flex2, styles.flex2_layout)}>
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                      <div
                        className={cn(
                          styles.text_body,
                          styles.text_body_layout
                        )}
                      >
                        {"Existing Battery A"}
                      </div>
                      <input
                        name="existingBatteryIdA"
                        className={cn(styles.line1, styles.line1_layout)}
                        value={formValues?.existingBatteryIdA}
                        disabled={readOnlyField}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className={cn(styles.flex2_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                      <div
                        className={cn(
                          styles.text_body,
                          styles.text_body_layout
                        )}
                      >
                        {"Exchanged Battery A"}
                      </div>
                      <input
                        name="exchangeBatteryIdA"
                        className={cn(styles.line1, styles.line1_layout)}
                        value={formValues?.exchangeBatteryIdA}
                        disabled={readOnlyField}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                </div>
                <div className={cn(styles.flex2, styles.flex2_layout)}>
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                      <div
                        className={cn(
                          styles.text_body,
                          styles.text_body_layout
                        )}
                      >
                        {"Current Charge"}
                      </div>
                      <input
                        name="existingBatteryAcurrentCharge"
                        className={cn(styles.line1, styles.line1_layout)}
                        value={formValues?.existingBatteryAcurrentCharge}
                        disabled={readOnlyField}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className={cn(styles.flex2_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                      <div
                        className={cn(
                          styles.text_body,
                          styles.text_body_layout
                        )}
                      >
                        {"Current Charge"}
                      </div>
                      <input
                        name="exchangeBatteryAcurrentCharge"
                        className={cn(styles.line1, styles.line1_layout)}
                        value={formValues?.exchangeBatteryAcurrentCharge}
                        disabled={readOnlyField}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                </div>
                <div className={cn(styles.flex2, styles.flex2_layout)}>
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                      <div
                        className={cn(
                          styles.text_body,
                          styles.text_body_layout
                        )}
                      >
                        {"Existing Battery B"}
                      </div>
                      <input
                        name="existingBatteryIdB"
                        className={cn(styles.line1, styles.line1_layout)}
                        value={formValues?.existingBatteryIdB}
                        disabled={readOnlyField}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className={cn(styles.flex2_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                      <div
                        className={cn(
                          styles.text_body,
                          styles.text_body_layout
                        )}
                      >
                        {"Exchanged Battery B"}
                      </div>
                      <input
                        name="exchangeBatteryIdB"
                        className={cn(styles.line1, styles.line1_layout)}
                        value={formValues?.exchangeBatteryIdB}
                        disabled={readOnlyField}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                </div>
                <div className={cn(styles.flex2, styles.flex2_layout)}>
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                      <div
                        className={cn(
                          styles.text_body,
                          styles.text_body_layout
                        )}
                      >
                        {"Current Charge"}
                      </div>
                      <input
                        name="existingBatteryBcurrentCharge"
                        className={cn(styles.line1, styles.line1_layout)}
                        value={formValues?.existingBatteryBcurrentCharge}
                        disabled={readOnlyField}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className={cn(styles.flex2_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                      <div
                        className={cn(
                          styles.text_body,
                          styles.text_body_layout
                        )}
                      >
                        {"Current Charge"}
                      </div>
                      <input
                        name="exchangeBatteryBcurrentCharge"
                        className={cn(styles.line1, styles.line1_layout)}
                        value={formValues?.exchangeBatteryBcurrentCharge}
                        disabled={readOnlyField}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                </div>
              </div>
              {id != undefined ? (
                ""
              ) : (
                <div className={cn(styles.flex2, styles.flex2_layout)}>
                  <div className={cn(styles.flex9, styles.flex9_layout)}>
                    <div className={cn(styles.flex9_item)}>
                      <Link to={{
                        pathname: "/Invoice",
                        state: {
                          compomentRenderType: "view"
                        }
                      }}>
                        <div
                          className={cn(styles.block7, styles.block7_layout)}
                          style={{ cursor: "pointer" }}
                        >
                          <h5
                            className={cn(
                              styles.highlights1,
                              styles.highlights1_layout
                            )}
                          >
                            {"Cancel"}
                          </h5>
                        </div>
                      </Link>
                    </div>
                    <div className={cn(styles.flex9_spacer)} />
                    <div className={cn(styles.flex9_item)}>
                      <div
                        onClick={calculateInvoice}
                        className={cn(styles.block8, styles.block8_layout)}
                        style={{ cursor: "pointer" }}
                      >
                        <h5
                          className={cn(
                            styles.highlights2,
                            styles.highlights2_layout
                          )}
                        >
                          {"calculate"}
                        </h5>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </form>
          </div>
          {/* //------- */}

          {showInvoice ? (
            <div className={cn(styles.group, styles.group_layout)}>
              <form>
                <div className={cn(styles.flex3, styles.flex3_layout)}>
                  <h3 className={cn(styles.subtitle, styles.subtitle_layout)}>
                    {"Energy Details"}
                  </h3>
                  <hr className={cn(styles.line, styles.line_layout)} />
                  <div className={cn(styles.flex2, styles.flex2_layout)}>
                    <div className={cn(styles.flex2_item)}>
                      <div className={cn(styles.block3, styles.block3_layout)}>
                        <div
                          className={cn(
                            styles.text_body,
                            styles.text_body_layout
                          )}
                        >
                          {"Total Energy Recieved"}
                        </div>
                        <input
                          name="totalEnergyReceived"
                          className={cn(styles.line1, styles.line1_layout)}
                          value={
                            id != undefined
                              ? formValues?.totalEnergyReceived
                              : invoiceDetails?.totalEnergyReceived
                          }
                          disabled={readOnlyField}
                          onChange={handleChange}
                        />
                      </div>
                    </div>

                    <div className={cn(styles.flex2_spacer)} />
                    <div className={cn(styles.flex2_item)}>
                      <div className={cn(styles.block3, styles.block3_layout)}>
                        <div
                          className={cn(
                            styles.text_body,
                            styles.text_body_layout
                          )}
                        >
                          {"Total Energy Given"}
                        </div>
                        <input
                          name="totalEnergyGiven"
                          className={cn(styles.line1, styles.line1_layout)}
                          value={
                            view != undefined
                              ? formValues?.totalEnergyGiven
                              : invoiceDetails?.totalEnergyGiven
                          }
                          disabled={readOnlyField}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </form>
              <div className={cn(styles.flex2, styles.flex2_layout)}></div>
            </div>
          ) : (
            ""
          )}

          {showInvoice ? (
            <div className={cn(styles.group, styles.group_layout)}>
              <form>
                <div className={cn(styles.flex3, styles.flex3_layout)}>
                  <div className={cn(styles.flex5, styles.flex5_layout)}>
                    <div className={cn(styles.flex2_item)}>
                      <div className={cn(styles.block3, styles.block3_layout)}>
                        <div
                          className={cn(
                            styles.text1_body,
                            styles.text1_body_layout
                          )}
                        >
                          {"Unit Energy Cost (₹)"}
                        </div>
                      </div>
                    </div>

                    <div className={cn(styles.flex5_spacer)} />
                    <div className={cn(styles.flex2_item)}>
                      <div className={cn(styles.block3, styles.block3_layout)}>
                        <div
                          className={cn(
                            styles.text1_body,
                            styles.text1_body_layout
                          )}
                          style={{ fontWeight: "lighter" }}
                        >
                          {id != undefined
                            ? Number(formValues?.unitEnergyCost).toFixed(2)
                            : Number(invoiceDetails?.unitEnergyCost).toFixed(2)}
                        </div>
                      </div>
                    </div>

                    <div className={cn(styles.flex5_spacer)} />
                    <div className={cn(styles.flex2_item)}>
                      <div className={cn(styles.block3, styles.block3_layout)}>
                        <div
                          className={cn(
                            styles.text1_body,
                            styles.text1_body_layout
                          )}
                        >
                          {"Total Energy Exchanges (in kWh)"}
                        </div>
                      </div>
                    </div>

                    <div className={cn(styles.flex5_spacer)} />
                    <div className={cn(styles.flex2_item)}>
                      <div className={cn(styles.block3, styles.block3_layout)}>
                        <div
                          className={cn(
                            styles.text1_body,
                            styles.text1_body_layout
                          )}
                          style={{ fontWeight: "lighter" }}
                        >
                          {id != undefined
                            ? (Number(formValues?.totalEnergyExchanges).toFixed(2) + " kWh")
                            : (Number(invoiceDetails?.totalEnergyExchanged).toFixed(2)) + " kWh"}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={cn(styles.flex5, styles.flex5_layout)}>
                    <div className={cn(styles.flex2_item)}>
                      <div className={cn(styles.block3, styles.block3_layout)}>
                        <div
                          className={cn(
                            styles.text1_body,
                            styles.text1_body_layout
                          )}
                        >
                          {"Total Energy Exchanged (in INR)"}
                        </div>
                      </div>
                    </div>

                    <div className={cn(styles.flex5_spacer)} />
                    <div className={cn(styles.flex2_item)}>
                      <div className={cn(styles.block3, styles.block3_layout)}>
                        <div
                          className={cn(
                            styles.text1_body,
                            styles.text1_body_layout
                          )}
                          style={{ fontWeight: "lighter" }}
                        >
                          {id != undefined
                            ? Number(formValues?.totalEnergyExchangeINR).toFixed(2)
                            : Number(invoiceDetails?.totalEnergyPrice).toFixed(2)}
                        </div>
                      </div>
                    </div>

                    <div className={cn(styles.flex5_spacer)} />
                    <div className={cn(styles.flex2_item)}>
                      <div className={cn(styles.block3, styles.block3_layout)}>
                        <div
                          className={cn(
                            styles.text1_body,
                            styles.text1_body_layout
                          )}
                        >
                          {"Mode of Payment"}
                        </div>
                      </div>
                    </div>

                    <div className={cn(styles.flex5_spacer)} />
                    <div className={cn(styles.flex2_item)}>
                      <div className={cn(styles.block3, styles.block3_layout)}>
                        <div
                          className={cn(
                            styles.text1_body,
                            styles.text1_body_layout
                          )}
                          style={{ fontWeight: "lighter" }}
                        >
                          {modeOfPayment}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
              <div className={cn(styles.flex2, styles.flex2_layout)}></div>
            </div>
          ) : (
            ""
          )}
          {/* -- */}

          {showInvoice ? (
            <div className={cn(styles.group, styles.group_layout)}>
              <div className={cn(styles.flex3, styles.flex3_layout)}>
                <h3 className={cn(styles.subtitle, styles.subtitle_layout)}>
                  {"Tax Details"}
                </h3>
                <hr className={cn(styles.line, styles.line_layout)} />
                {/* <div className={cn(styles.flex2, styles.flex2_layout)}> */}
                {/* <div className={cn(styles.flex2_item)}> */}
                {/* <div className={cn(styles.block3, styles.block3_layout)}> */}
                {/* <Styles> */}
                <Styles style={{ marginBottom: "-60px" }}>
                  <Table noPaging={true} columns={columns} data={data} />
                </Styles>
                {/* </Styles> */}
                {/* </div> */}
                {/* </div> */}
                {/* <div className={cn(styles.flex2_spacer)} /> */}
                {/* </div> */}
                <div className={cn(styles.group1, styles.group1_layout)}>
                  <form>
                    <div className={cn(styles.flex3, styles.flex3_layout)}>
                      <div className={cn(styles.flex2, styles.flex2_layout)}>
                        <div className={cn(styles.flex2_item)}>
                          <div
                            className={cn(styles.block3, styles.block3_layout)}
                          >
                            <div
                              className={cn(
                                styles.text1_body,
                                styles.text1_body_layout
                              )}
                            >
                              {"Total Amount To Pay ( in INR. )"}
                            </div>
                          </div>
                        </div>

                        <div className={cn(styles.flex2_spacer)} />
                        <div
                          className={cn(
                            styles.text1_body,
                            styles.text1_body_layout
                          )}
                        >
                          {invoiceDetails?.totalAmountToPay}
                        </div>
                      </div>
                    </div>
                    <div className={cn(styles.flex2_item)}>
                      <div className={cn(styles.block3, styles.block3_layout)}>
                        <div
                          className={cn(
                            styles.text_body,
                            styles.text_body_layout
                          )}
                        >
                          {"Remarks"}
                        </div>

                        {view != undefined ?
                          <div style={{ padding: "10px" }}>{formValues?.remark}</div> :
                          <><textarea
                            name="remark"
                            rows="4"
                            cols="50"
                            maxlength="250"
                            value={formValues?.remark}
                            placeholder="Enter Remarks Here"
                            className={cn(styles.line1, styles.line1_layout)}
                            disabled={view != undefined ? true : false}
                            onChange={handleChange}
                          />
                            <p>{formErrors.remark}</p>
                          </>
                        }
                      </div>
                    </div>
                  </form>
                </div>

                {/* //------- */}
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
        {showInvoice ? (
          <div
            className={
              !updateView
                ? cn(styles.flex9, styles.flex9_layout_2)
                : cn(styles.flex9, styles.flex9_layout_3)
            }
          >
            <div className={cn(styles.flex9_item)}>
              {/* <Link to="/Invoice"> */}
              <Link to={{
                pathname: "/Invoice",
                state: { compomentRenderType: "view" }
              }}>
                <div
                  className={cn(styles.block7, styles.block7_layout)}
                  style={{ cursor: "pointer" }}
                >
                  <h5
                    className={cn(
                      styles.highlights1,
                      styles.highlights1_layout
                    )}
                  >
                    {"Cancel"}
                  </h5>
                </div>
              </Link>
            </div>
            <div className={cn(styles.flex9_spacer)} />
            {!updateView ? (
              <div className={cn(styles.flex9_item)}>
                <div
                  onClick={handleSubmit}
                  className={cn(styles.block8, styles.block8_layout)}
                  style={{ cursor: "pointer" }}
                >
                  <h5
                    className={cn(
                      styles.highlights2,
                      styles.highlights2_layout
                    )}
                  >
                    {action}
                  </h5>
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        ) : (
          ""
        )}
      </div>
    </>
  );
}

export default function AddInvoice(props) {
  return (
    <>
      <Master opts={props} screen={AddInvoiceView} showStatus={false} />
    </>
  );
}

AddInvoice.inStorybook = true;
